/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import SponsorLogo from '../../../assets/icons/SponsorLogo.svg';
import { useInputValue } from '../../../utils/hooks/useInputValue';
import { AdBodyForm, AdBodyFormUp } from '../styles';
import { EdBody, EdBodyFormMid, EdBodyFormMidWrapper, EdCancelFooter, EdFooter } from './styles';
import { AdBodyFormBottom, AdBodyFormBottomLeft, AdBodyFormBottomRight } from '../addPlayers/styles';
import { InputComponent, Label, LargeButton, Loader, PowerDropdown, PowerInput, TeamLogo, TextWarning } from '../../../components';
import { Teams, Utils, Admin } from '../../../utils/api';
import { useContext } from 'react';
import { ARMcontext } from '../../../utils/context/context';
import { defaultSponsor as sponsors, TYPES_INVITATIONS, SPONSOR_SELECTED_DEFAULT, INVITE_SELECTED_DEFAULT } from '../../../utils/constants/defaultSponsor';

export const IndividualPlayer = ({
  teamMemo,
  item,
  index,
  useSelectedPlayers,
  useError,
  membershipsYearly,
  membershipsYearlyCount,
  changeMembershipsYearly,
  membershipsYearlyTotal,
}) => {
  const [team, useTeam] = useState<any>([]);
  let sponsorInit: any;
  if (item?.invitationType === TYPES_INVITATIONS.SPONSOR_PLAYER) sponsorInit = SPONSOR_SELECTED_DEFAULT;
  else sponsorInit = INVITE_SELECTED_DEFAULT;

  const [defaultSponsor, setDefaultSponsor] = useState<Array<object>>(sponsors);
  const [sponsor, useSponsor] = useState<any>(sponsorInit || SPONSOR_SELECTED_DEFAULT);
  const [selectedBlock, setSelectedBlock] = useState<any>(item?.block);
  const [membershipBlock, setMembershipBlock] = useState<any>([]);
  const [indexSelectedMembership, setIndexSelectedMembership] = useState<number>(-1);
  const emailName = useInputValue(item.email, '', 'normal', '', 'email');
  const firstName = useInputValue(item.firstName);
  const lastName = useInputValue(item.lastName);
  const UTILS = new Utils();
  const isValidInput = UTILS.GetValidationInputPattern();
  const isBlankInput = UTILS.GetValidationBlankPattern();
  const isValidEmail = UTILS.GetValidationEmailPattern();

  useEffect(() => {
    /*** If the player has an active sponsor invite, the subscription name: 'Invite Player' is changed to 'Stop Sponsorship'*/
    if (item.invitationType === TYPES_INVITATIONS.SPONSOR_PLAYER && item.status === 'Active') {
      let copySponsors = JSON.parse(JSON.stringify(sponsors));
      copySponsors.forEach((element: any) => {
        element['name'] = element['value'] === TYPES_INVITATIONS.INVITE_PLAYER ? 'Stop Sponsorship' : element['name']
      });
      setDefaultSponsor(copySponsors);
    }
  }, [])

  useEffect(() => {
    if (!Boolean(firstName.value.length) || isBlankInput.test(firstName.value)) {
      firstName.HandleWarning('This field cannot be empty');
      firstName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 1).length)) {
          return prev;
        } else {
          return [...prev, { index: 1 }];
        }
      });
    } else if (!isValidInput.test(firstName.value)) {
      firstName.HandleWarning('This field does not allow special characters');
      firstName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 1).length)) {
          return prev;
        } else {
          return [...prev, { index: 1 }];
        }
      });
    } else {
      firstName.HandleWarning('');
      firstName.HandleStatus('normal');
      useError(prev => {
        return prev.filter(el => el.index !== 1);
      });
    }
    infoChange({ firstName: firstName.value });
  }, [firstName.value]);

  useEffect(() => {
    if (!Boolean(lastName.value.length) || isBlankInput.test(lastName.value)) {
      lastName.HandleWarning('This field cannot be empty');
      lastName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 2).length)) {
          return prev;
        } else {
          return [...prev, { index: 2 }];
        }
      });
    } else if (!isValidInput.test(lastName.value)) {
      lastName.HandleWarning('This field does not allow special characters');
      lastName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 2).length)) {
          return prev;
        } else {
          return [...prev, { index: 2 }];
        }
      });
    } else {
      lastName.HandleWarning('');
      lastName.HandleStatus('normal');
      useError(prev => {
        return prev.filter(el => el.index !== 2);
      });
    }
    infoChange({ lastName: lastName.value });
  }, [lastName.value]);

  useEffect(() => {
    if (!Boolean(emailName.value.length)) {
      emailName.HandleWarning('This field cannot be empty');
      emailName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 3).length)) {
          return prev;
        } else {
          return [...prev, { index: 3 }];
        }
      });
    } else if (!isValidEmail.test(emailName.value)) {
      emailName.HandleWarning('Invalid email');
      emailName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 3).length)) {
          return prev;
        } else {
          return [...prev, { index: 3 }];
        }
      });
    } else {
      emailName.HandleWarning('');
      emailName.HandleStatus('normal');
      useError(prev => {
        return prev.filter(el => el.index !== 3);
      });
    }
    infoChange({ email: emailName.value });
  }, [emailName.value]);

  function AlternateFocus(hook: any) {
    hook.HandleStatus('normal');
    hook.HandleWarning('');
  }

  function AddTeam(selectedTeam: any): void {
    useTeam(prev => {
      if (Boolean(prev.filter(el => el.badge === 'ALL').length)) {
        const modTeams = [...prev];
        infoChange({ team: modTeams });
        return modTeams;
      } else if (Boolean(prev.length) && selectedTeam.badge === 'ALL') {
        const modTeams = [...prev];
        infoChange({ team: modTeams });
        return modTeams;
      } else if (!Boolean(prev.filter(el => selectedTeam._id === el._id).length)) {
        const modTeams = [...prev, selectedTeam];
        infoChange({ team: modTeams });
        return modTeams;
      } else {
        const modTeams = [...prev];
        infoChange({ team: modTeams });
        return modTeams;
      }
    });
  }

  function handleCancelBadge(element) {
    const teamData = [...team.filter(el => element._id !== el._id)];
    useTeam(teamData);
    infoChange({ team: teamData });
  }

  function ChangeSponsor(selectedOption: any) {
    if (selectedOption.value === TYPES_INVITATIONS.SPONSOR_PLAYER) {
      setMembershipBlock(membershipsYearly)
    }
    if (selectedOption !== sponsor && indexSelectedMembership > -1) {
      let updateArray
      if (membershipBlock.length) {
        updateArray = [...membershipBlock];
      }
      else {
        updateArray = [...membershipsYearly]
      }
      updateArray[indexSelectedMembership].selected = false;
      changeMembershipsYearly(updateArray);
      setIndexSelectedMembership(-1);
    }
    setSelectedBlock(undefined);
    useSponsor(selectedOption);
   infoChange({ sponsor: selectedOption });
  }

  function ChangeBlock(selectedOption: any) {
    let updateArray
    if (membershipBlock.length) {
      updateArray = [...membershipBlock];
    }
    else {
      updateArray = [...membershipsYearly]
    }
    let option = selectedOption;
    if (option.name === 'new') {
      option = updateArray.find(item => item.unused && !item.selected)
    }
    let index = updateArray.indexOf(option);
    if (indexSelectedMembership > -1) {
      updateArray[indexSelectedMembership].selected = false;
    }
    updateArray[index].selected = true;
    changeMembershipsYearly(updateArray);
    setIndexSelectedMembership(index);
    setSelectedBlock(option);
    infoChange({ block: option });
  }

  function infoChange({
    team,
    email,
    sponsor,
    position,
    lastName,
    firstName,
    block,
  }: {
    email?: string;
    lastName?: string;
    firstName?: string;
    team?: object | any;
    sponsor?: object | any;
    position?: Array<any> | any;
    block?: object | any;
  }) {
    useSelectedPlayers(prev => [
      ...prev.map((el, id) => {
        if (id !== index) {
          return el;
        } else {
          if (firstName) {
            el.firstName = firstName;
          }
          if (lastName) {
            el.lastName = lastName;
          }
          if (team) {
            el.team = team;
          }
          if (position) {
            el.position = position;
          }
          if (email) {
            el.email = email;
          }
          if (sponsor) {
            el.invitationType = sponsor.value;
            delete el.block;
          }
          if (block) {
            el.block = block;
          }
          return el;
        }
      }),
    ]);
  }

  function parseDateYearlyMembership(date: string) {
    let nDate = new Date(date);
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[nDate.getMonth()] + " " + nDate.getUTCDate() + "-" + String(nDate.getFullYear()).substring(2, 4);
  }

  return (
    <AdBodyForm data-cy="editPlayers-form">
      <AdBodyFormUp>
        <div style={{ width: '200px', marginRight: '10px' }}>
          <Label text="FIRST NAME" fontWeight="600" fontSize="12px" />
          <InputComponent
            dynamicSearch={firstName}
            animateWidth="100%"
            idKey="1"
            HandleFocus={() => AlternateFocus(firstName)}
            maxLength={20}
          />
          <TextWarning status={firstName.status} message={firstName.warningMessage} display="block" />
        </div>
        <div style={{ width: '200px', marginRight: '10px' }}>
          <Label text="LAST NAME" fontWeight="600" fontSize="12px" />
          <InputComponent
            dynamicSearch={lastName}
            animateWidth="100%"
            idKey="2"
            HandleFocus={() => AlternateFocus(lastName)}
            maxLength={20}
          />
          <TextWarning status={lastName.status} message={lastName.warningMessage} display="block" />
        </div>
        <div style={{ width: '100%' }}>
          <Label text="EMAIL" fontWeight="600" fontSize="12px" />
          <InputComponent dynamicSearch={emailName} animateWidth="100%" idKey="3" HandleFocus={() => AlternateFocus(emailName)} />
          <TextWarning status={emailName.status} message={emailName.warningMessage} display="block" />
        </div>
      </AdBodyFormUp>
      <EdBodyFormMid>
        <EdBodyFormMidWrapper>
          <Label text="TEAM" fontWeight="600" fontSize="12px" />
          <PowerInput maxWidth="100%" search={true} onClick={AddTeam} dataArray={teamMemo} selectedTeams={item?.team?.length && item.team} handleCancel={handleCancelBadge} />
        </EdBodyFormMidWrapper>
      </EdBodyFormMid>
      <AdBodyFormBottom>
        <AdBodyFormBottomLeft>
          <TeamLogo src={SponsorLogo} mTop="10px" />
        </AdBodyFormBottomLeft>
        <AdBodyFormBottomRight>
          <PowerDropdown
            mHeigth="132px"
            onClick={ChangeSponsor}
            search={false}
            dataArray={defaultSponsor}
            primaryTitle={sponsor.name}
            mPadding="4px 0 4px 10px"
            membershipCount={{ yearly: membershipsYearlyTotal, selected: 0 }}
          />
          {sponsor.value === TYPES_INVITATIONS.SPONSOR_PLAYER && (
            <div style={{ height: '45px', minWidth: '305px' }}>
              <PowerDropdown
                search={false}
                mHeigth="132px"
                firstActve={true}
                onClick={ChangeBlock}
                dataArray={membershipBlock}
                primaryTitle={selectedBlock ? (!selectedBlock.unused && selectedBlock.endDate ?
                  `${selectedBlock?.remainingPeriod} Remaining | EXP: ${parseDateYearlyMembership(selectedBlock?.endDate)}` :
                  `Enrolled`) : 'Select option'}
                mPadding="4px 0 4px 10px"
                membershipInfo={{ name: sponsor.value, count: membershipsYearlyCount }}
              />
            </div>
          )}
        </AdBodyFormBottomRight>
      </AdBodyFormBottom>
    </AdBodyForm>
  );
};

export default ({ teamMemo, handleView, selectedPlayers, useSelectedPlayers }) => {
  const { HandleToastMessage } = useContext(ARMcontext);
  const [error, useError] = useState<Array<any>>([]);
  const [validate, useValidate] = useState<Boolean>(false)
  const [loading, useLoading] = useState(false);
  const [membershipsYearly, setMembershipsYearly] = useState<any>();
  const [membershipsYearlyCount, setMembershipsYearlyCount] = useState<any>();
  const [membershipsYearlyTotal, setMembershipsYearlyTotal] = useState<number>(0);
  const TEAMS = new Teams();
  const ADMIN = new Admin();
  const [,...newTeamMemo] = teamMemo
  useEffect(() => {
    FetchMembershipYearly();
  }, []);

  useEffect(() => {
    setMembershipsYearlyCount(newMembershipsCount(membershipsYearly));
    if (membershipsYearly) {
      setMembershipsYearlyTotal([...membershipsYearly.filter(item => !item.selected)].length);
    }
  }, [membershipsYearly]);

  function StartValidations(): void {
    selectedPlayers.forEach((elem, index) => {
      
      let sponsor = elem.invitationType ? elem.invitationType : elem.payment
      /**
       * If the subscription is equal to sponsor, it is validated that it has an available subscription selected
       */
      
       if (sponsor === SPONSOR_SELECTED_DEFAULT.value) {
        if (!elem.block) {
          useError(prev => [...prev, { index: index }])
        }
       }
    })
    useValidate(true)
  }

  useEffect(() => {
    if (validate) {
      if (!error.length) {
        HandleSubmit();
      }
      else {
        HandleToastMessage('Select an option for Sponsorship Player dropdown on invitation ' + (error[0].index + 1), true, 2000, 'error');
        useError([]);
      }
      useValidate(false)
    }
  }, [validate]);

  async function FetchMembershipYearly(): Promise<void> {
    const resMemberShip = await ADMIN.GetMembershipsAvailable('yearly');
    setMembershipsYearly(resMemberShip.data.data.map(membership =>
      ({ ...membership, selected: false, type: 'yearly' })));
  }

  function newMembershipsCount(block) {
    if (block)
      return block.filter(item => !item.selected && item.unused).length
    return 0
  }

  function HandleSubmit() {
    useLoading(true);
    const invitationIDs = selectedPlayers.map(el => el._id);
    const recoveData = selectedPlayers.map(el => {
      const teams = el.team?.map(team => team._id)?.filter(team => team !== undefined);
      let invitationType: any;
      if (el?.invitationType === 'Basic' || el?.invitationType === 'Player Paid' ||
        el?.invitationType === 'Premium' || el?.invitationType === 'Inactive') {
        invitationType = 'Join';
      } else {
        invitationType = el.invitationType;
      }
      const memoryData = {
        firstName: el.firstName,
        lastName: el.lastName,
        email: el.email,
        invitationType: invitationType,
        team: teams,
        block: el?.block?.blockId || el?.block?._id,
      };

      return memoryData;
    });
    const results = invitationIDs.map((el, idx) => {
      return TEAMS.UpdatePlayerInvitation(el, recoveData[idx]);
    });

    Promise.all(results).then((data: any) => {
      if (data[0]?.statusCode === 409 || data[0]?.success===false) {
        HandleToastMessage(data[0].message, true, 5000, 'error');
        useLoading(false);
        
      }else {
        HandleToastMessage('Invitations updated', true, 2500, 'success');
        useLoading(false);
        handleView(false, true);
      }
    });
  }

  return (
    <>
      <EdBody>
        {selectedPlayers.map((el, idx) => (
          <IndividualPlayer
            key={idx}
            index={idx}
            teamMemo={newTeamMemo}
            item={el}
            useSelectedPlayers={useSelectedPlayers}
            useError={useError}
            membershipsYearly={membershipsYearly}
            membershipsYearlyCount={membershipsYearlyCount}
            membershipsYearlyTotal={membershipsYearlyTotal}
            changeMembershipsYearly={setMembershipsYearly}
          />
        ))}
      </EdBody>
      <EdFooter>
        <EdCancelFooter>
          <LargeButton
            lMargin="0"
            title="CANCEL"
            rMargin="0 40px"
            rColor="#ffffff"
            lColor="#ffffff"
            fColor="#5D6C76"
            bColor="#F0F0F0"
            xMargin="0 10px 0 0"
            dataCy="editPlayers-cancel"
            callback={() => handleView(false)}
          />
          {loading ? (
            <Loader width="190px" />
          ) : (
            <LargeButton
              icon="done"
              rColor="#007AFF"
              lColor="#006BE1"
              title="Save Changes"
              callback={StartValidations}
              dataCy="editPlayers-submit"
            />
          )}
        </EdCancelFooter>
      </EdFooter>
    </>
  );
};
